import {
  okResponseSchema,
  sessionResponseSchema,
  type ChangePasswordRequest,
  type ForgotPasswordRequest,
  type LoginRequest,
  type OkResponse,
  type RegisterRequest,
  type ResetPasswordRequest,
  type SessionResponse,
  type UpdateSettingsRequest,
} from '@firegame/shared';
import { request } from './client.js';

/** Appels d'authentification. Toutes les reponses sont validees avant usage. */

export function fetchSession(signal?: AbortSignal): Promise<SessionResponse> {
  return request<SessionResponse>('/auth/me', sessionResponseSchema, {
    method: 'GET',
    ...(signal ? { signal } : {}),
  });
}

export function register(body: RegisterRequest): Promise<SessionResponse> {
  return request<SessionResponse>('/auth/register', sessionResponseSchema, {
    method: 'POST',
    body,
  });
}

export function login(body: LoginRequest): Promise<SessionResponse> {
  return request<SessionResponse>('/auth/login', sessionResponseSchema, { method: 'POST', body });
}

export function logout(): Promise<OkResponse> {
  return request<OkResponse>('/auth/logout', okResponseSchema, { method: 'POST' });
}

export function forgotPassword(body: ForgotPasswordRequest): Promise<OkResponse> {
  return request<OkResponse>('/auth/forgot-password', okResponseSchema, { method: 'POST', body });
}

export function resetPassword(body: ResetPasswordRequest): Promise<OkResponse> {
  return request<OkResponse>('/auth/reset-password', okResponseSchema, { method: 'POST', body });
}

export function changePassword(body: ChangePasswordRequest): Promise<OkResponse> {
  return request<OkResponse>('/auth/change-password', okResponseSchema, { method: 'POST', body });
}

export function updateSettings(body: UpdateSettingsRequest): Promise<SessionResponse> {
  return request<SessionResponse>('/auth/settings', sessionResponseSchema, { method: 'PUT', body });
}
